exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.job-value[data-v-a796cc04] {\n  font-size: 20px;\n  font-weight: 500;\n}\n.job-status[data-v-a796cc04] {\n  font-size: 12px;\n  font-weight: 400;\n  color: #bec0ca;\n}\n.in-progress-title[data-v-a796cc04] {\n  font-size: 12px;\n  font-weight: 400;\n  color: #ffffff;\n}\n.in-progress-value[data-v-a796cc04] {\n  font-size: 20px;\n  font-weight: 500;\n  color: #ffffff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a796cc04","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/salesDashboard/subcomponents/cards/CanceledOnHoldJobs.vue
// module id = exVy
// module chunks = 0